<template>
  <div class="product-reviews">
    <ul class="reviews">
      <li
        v-for="(review, index) in reviews"
        :key="index"
        class="review-item"
      >
        <div class="review-item-header">
          <div
            v-if="review.date"
            class="review-date"
          >
            {{ review.date | formatDate }}
          </div>
          <div class="review-item-title">
            <h3> {{ review.title }} </h3>
          </div>
          <div class="review-item-subtitle">
            <h4>{{ review.subtitle }}</h4>
          </div>
        </div>
        <div class="review-item-description">
          {{ review.review }}
        </div>
        <div class="points-container">
          <div class="points">
            <span class="number">
              {{ review.points }}
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'product-reviews',
  filters: {
    formatDate(val) {
      let date = dayjs(val)
      if (date.isValid()) {
        return date.format('MMMM, YYYY')
      }
      return 'N/A'
    }
  },
  props: {
    reviews: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.reviews {
  display: grid;
  grid-gap: 1.5em;
  margin:0;
  padding:0;
  grid-template-columns: repeat(1, 1fr);
  margin-bottom: 2.5em;
  list-style:none;

  @include media-breakpoint-up(md) { grid-template-columns: repeat(2, 1fr); }
  @include media-breakpoint-up(lg) { grid-template-columns: repeat(3, 1fr); }

  .review-item-header {
  padding-bottom: 1em;
  margin-bottom: 1em;
  border-bottom:1px solid;
  border-color:var(--main-border-color);
  }

  .review-item-subtitle {
    opacity:.5;
  }

  .review-item-description {
    margin-bottom:1em;
  }

  .review-item {
    border: 2px solid var(--main-white);
    padding: 2em 1em;
    display:flex;
    flex-direction:column;
    position: relative;
    transition: ease-in-out all .2s;
    background-color:var(--main-product-detail-card-color);

    .points-container {
      display: flex;
      align-items: flex-end;
      height: 100%;

      .points { color: var(--main-product-detail-card-highlight-color); }
      .number { font-size: 2em; }

      .unit {
        font-weight: bold;
        font-size: 1.5em;
      }
    }
  }
}

</style>
